export function isMenuPath (path: string): boolean {
    return isDeliveryPath(path) || isPickupPath(path)
}

export function isDeliveryPath (path: string): boolean {
    return path.includes('/shop') && !isPickupPath(path)
}

export function isPickupPath (path: string): boolean {
    return path.includes('/pickup')
}

export function isCheckoutPath (path: string): boolean {
    return path.includes('/checkout')
}

export function isAccountPath (path: string): boolean {
    return path.includes('/account')
}
